export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6213.9d509bae.jpg";